import React, { useMemo, useRef } from 'react';

import { useIntl } from 'react-intl-next';

import { NowLocation } from '../../../../utils/constants/schedule';
import { getNowLocation } from '../../../../utils/schedule';

import { Cell, Container, Day, Grid, Stripe } from './styled';
import { type WeekProps } from './types';
import { generateWeekDays } from './utils';

const Week = ({ nowEpoch, startEpoch, endEpoch, offset, rotationSlot }: WeekProps) => {
	const intlApi = useIntl();
	const ref = useRef<HTMLDivElement>(null);

	const days = useMemo(
		() => generateWeekDays(intlApi)(startEpoch, offset),
		[intlApi, offset, startEpoch],
	);

	const isInWeek = getNowLocation(startEpoch, endEpoch, nowEpoch) === NowLocation.InRange;

	return (
		<Container ref={ref}>
			<Grid aria-hidden>
				{days.map(({ text, dayStartEpoch, dayEndEpoch, isFirstDay }) => (
					<Cell key={`${dayStartEpoch}-${dayEndEpoch}`}>
						<Day
							isLong={isFirstDay}
							nowLocation={getNowLocation(dayStartEpoch, dayEndEpoch, nowEpoch)}
						>
							{text}
						</Day>
					</Cell>
				))}
			</Grid>

			{rotationSlot}

			{isInWeek && (
				<Stripe
					data-testid="indicator"
					nowEpoch={nowEpoch}
					endEpoch={endEpoch}
					startEpoch={startEpoch}
				/>
			)}
		</Container>
	);
};

export { Week };
